import React from "react";
import PropTypes from "prop-types";
import { HexActiveIcon, HexIcon } from "../../Icons";
import { Image } from "@learningblocks/shared-components";
import "./style.scss";

/**
 * Single MenuItem for NavigationList
 * - A single menu item.
 */
export function NavigationMenu(props) {
  const goToSection = () => props.goToSection(props.scrollIndex);

  const getSrc = () => (props.menuActive ? HexActiveIcon : HexIcon);

  const highlightStyle = () => ({
    display: props.menuActive ? "initial" : "none",
    height: `${getHighlightHeight(props.totalMenus)}px`,
  });

  return (
    <div
      role="button"
      tabIndex={0}
      className="navMenu"
      onClick={goToSection}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          goToSection();
        }
      }}
    >
      <div className="navMenu-topLine" style={highlightStyle()} />
      <Image src={getSrc()} className="navMenu-hexagon" alt={props.title} />
      <div className="navMenu-title">{props.title}</div>
    </div>
  );
}

NavigationMenu.propTypes = {
  /**
   * The scroll-point to which to scroll to.
   */
  scrollIndex: PropTypes.number.isRequired,
  /**
   * The callback to be execucted when a point is clicked
   */
  goToSection: PropTypes.func.isRequired,
  /**
   * Boolean value specifying if the menu is active
   */
  menuActive: PropTypes.bool.isRequired,
  /**
   * Total number of menus
   */
  totalMenus: PropTypes.number.isRequired,
  /**
   * Title number to be displayed on Menu Item
   */
  title: PropTypes.string.isRequired,
};

function getHighlightHeight(totalNavs) {
  return (window.innerHeight - 20) * (100 / (totalNavs - 1) / 100) - 22;
}
